let genitiveMonths, nominativeMonths
if (localStorage.getItem('lang') === 'ru') {
  genitiveMonths = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
  ]
  nominativeMonths = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ]
} else {
  genitiveMonths = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
  ]
  nominativeMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
}
export const nameMonths = {
  data: () => ({
    genitiveMonths: genitiveMonths,
    nominativeMonths: nominativeMonths
  }),
  methods: {
    getGenMonthWithData(date) {
      let month_index = +date.substring(date.lastIndexOf('.') + 1)
      let month_name = this.genitiveMonths[month_index - 1]
      let day = date.substring(0, date.lastIndexOf('.'))
      if (day.startsWith('0')) {
        day = day.substring(1)
      }
      return `${day} ${month_name}`
    },
    getGenitiveMonths(date) {
      let month_index = date.month() + 1
      let month_name = this.genitiveMonths[month_index - 1]

      return month_name
    },
    getNominativeMonths(month_index) {
      month_index = month_index + 1
      let month_name = this.nominativeMonths[month_index - 1]

      return month_name
    }
  }
}
